import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  rules = 1,
  ranking,
}
export enum rewardTypeEnum {
  hour = 1,
  day = 2,
  week = 3,
  month = 4,
  diy = 5,
}
export const getPartnerPlanData = createAsyncThunk(
  'PartnerPlan_getPartnerPlanData',
  async (
    arg: {offset?: number; page_size?: number; id?: number},
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'union_rank_list'
          | 'offset'
          | 'more'
          | 'activity_expire'
          | 'activity_gifts'
        >
      >
    >(
      '/live/activity/pp_rank_list',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
      current_groupid: arg?.id,
      pageSize: arg?.page_size || 1,
    }
  }
)

export const getPartnerPlanConfig = createAsyncThunk(
  'PartnerPlan_getPartnerPlanConfig',
  async (_, store: any) => {
    const resp = await http.post(
      '/live/activity/pp_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface unionItem {
  mid: number
  name: string
  avatar: string
  zy_id: string
  score: number
}

interface giftType {
  gift_id: number
  avatar: string
  name: string
}

export interface unionRankType {
  union_id: number
  union_name: string
  union_income: number
  // 历史信息
  period?: Array<string>
  list?: Array<unionItem>
}

export interface myUnionType extends unionRankType {
  union_rank: string
  reward_need: number
}

interface InitialStateType {
  is_group?: boolean
  rank_rewards?: {
    id: number
    reward_items: []
    group_name: string
  }[]
  groups?: {
    id: number
    coins_area: string
    desc: string
  }[]
  period?: number
  group_id?: number
  activity_expire?: number // 倒计时 秒
  current_groupid?: number
  more?: boolean
  offset?: number
  union_rank_list?: Array<unionRankType> // 公会排行榜
  my_union_info?: myUnionType // 我的公会信息
  history_champion_list?: Array<unionRankType> // 历史冠军信息
  activity_gifts?: Array<giftType>
}

const initialState: InitialStateType = {
  is_group: false,
  current_groupid: 0,
}

export const PartnerPlanSlice = createSlice({
  name: 'PartnerPlan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPartnerPlanData.fulfilled, (state, action) => {
      if (
        state.current_groupid === action.payload.current_groupid &&
        action.payload.pageSize !== 1
      ) {
        const currentList = state.union_rank_list || []
        Object.assign(state, action.payload, {
          union_rank_list:
            currentList.concat(action.payload.union_rank_list || []) || [],
          activity_gifts: action.payload.activity_gifts,
        })
      } else {
        Object.assign(state, action.payload)
      }
    })
    builder.addCase(getPartnerPlanConfig.fulfilled, (state, action) => {
      Object.assign(state, action.payload, {
        current_groupid: action.payload.group_id,
      })
    })
  },
})
export default PartnerPlanSlice.reducer
